import short from 'short-uuid'

export const translator = short()

export const minimizeID = id => {
	try{
		return translator.fromUUID(id)
	}
	catch(e){
		// console.warn(e)
		return id
	}
}

export const maximizeID = id => {
	try{
		return translator.toUUID(id)
	}
	catch(e){
		// console.warn(e)
		return id
	}
}